import { render } from "./NavBarComponent.vue?vue&type=template&id=653e7946&ts=true"
import script from "./NavBarComponent.vue?vue&type=script&lang=ts"
export * from "./NavBarComponent.vue?vue&type=script&lang=ts"

import "./NavBarComponent.vue?vue&type=style&index=0&id=653e7946&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__